module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av722-beff9a4b39d479d799b9db8cbe9b260f.jpg";